import { HeadingMedium, LockIcon } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import PublicLayout from '../../components/Common/PublicLayout';
import storage from '../../lib/storage';
import { RoundLogo } from '../Login/Common';
import LoginAside from '../Login/LoginAside';
import RecoverPasswordSuccess from './RecoverPasswordSuccess';

const RecoverPasswordScreen = ({ match, history }: RouteComponentProps<any>) => {
  const [t] = useTranslation('recoverPassword');
  const lang = match.params.lang;
  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2);
  const emailSent = new URLSearchParams(history.location.search).get('email') ?? '';

  return (
    <PublicLayout basePath={'recoverPassword'} history={history} lang={detectedLang} aside={<LoginAside />}>
      <>
        <RoundLogo>
          <LockIcon />
        </RoundLogo>
        <HeadingMedium className="text-center">{t('setupNewPassword')}</HeadingMedium>
        <RecoverPasswordSuccess email={emailSent} />
      </>
    </PublicLayout>
  );
};

export default RecoverPasswordScreen;
